export default __webpack_public_path__ + "static/media/Group109.0c775008.png";